import { BREAKPOINT } from '@/constants/enum';
import styled from 'styled-components';

export const SettingsStyled = styled.div`
  .Polaris-Box--listReset {
    padding-top: 0;
    @media only screen and (max-width: ${BREAKPOINT.SM}px) {
      padding: 0;
      padding-bottom: 1rem;
    }
  }
  .settings-title-container {
    height: fit-content;
    position: sticky;
    top: 70px;
    .Polaris-OptionList-Option__Icon {
      display: none;
    }
    .Polaris-BlockStack {
      background-color: white;
      padding: 1rem;
      border-radius: 0.5rem;
    }
    .settings-title {
      display: flex;
      .Polaris-Icon {
        margin-right: 0.5rem;
      }
    }
  }
  .toggle-settings-title {
    line-height: 28px;
  }

  .date-and-time-container {
    .Polaris-DataTable__Cell:last-child {
      text-align: center;
    }
  }

  .Polaris-LegacyCard {
    border-radius: 0.75rem;
  }

  .wrap-content {
    .wrap-translate {
      position: sticky;
      top: 64px;
      z-index: 102;
    }
    .Polaris-Tabs__Outer {
      position: sticky;
      top: 130px;
      z-index: 102;
      > .Polaris-Box {
        background-color: white;
        border: 1px solid rgb(222 222 222);
        border-radius: 12px;
      }
    }
  }

  @media (max-width: 47.9975em) {
    .Polaris-Tabs__Outer {
      overflow: visible;
    }
  }
`;

export const MenuBarStyled = styled.div`
  width: 100%;
  background-color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  position: sticky;
  top: 0;
  z-index: 2;
`;
